module.exports = __webpack_public_path__ + "static/media/orthia.ea56c94e.png";